import { useI18n, type Lang } from '@/i18n'

export function LanguageSwitcher() {
  const { lang, switchLang, t } = useI18n()

  function onPick(next: Lang) {
    switchLang(next)
  }

  return (
    <div className="lang-switcher" role="group" aria-label={t.actions.language}>
      <button
        type="button"
        className={`lang-btn${lang === 'de' ? ' is-active' : ''}`}
        onClick={() => onPick('de')}
        aria-pressed={lang === 'de'}
        title="Deutsch"
      >
        DE
      </button>
      <span className="lang-sep" aria-hidden>
        |
      </span>
      <button
        type="button"
        className={`lang-btn${lang === 'en' ? ' is-active' : ''}`}
        onClick={() => onPick('en')}
        aria-pressed={lang === 'en'}
        title="English"
      >
        EN
      </button>
    </div>
  )
}
